module.exports = __webpack_public_path__ + "static/media/fight_knights.73e68ce6.JPG";